import { IPisRequest } from "../../../types/data.interface";
import Spinner from "../../../components/Spinner";
import { approverValidation } from "../helpers/approverValidation";

interface IStepActionButtonsProps {
  isFinished: boolean;
  pisRequest: IPisRequest;
  hasApproverPermission: boolean;
  hasGroup?: any;
  isSaveOrSubmitInProgress: boolean;
  onSave: any;
  onReject: any;
  onApprove: any;
  onSubmit: any;
  moveToStep: (step: any) => void;
  LAST_STEP_INDEX: number;
  step: {
    current: number;
    setStep: any;
    bias: [number, number];
    isDisabled: (s: any) => { messages: string; isReady: boolean };
  };
}

export const StepsActionButtons = ({
  step,
  hasApproverPermission,
  hasGroup,
  isFinished,
  pisRequest,
  isSaveOrSubmitInProgress,
  onSave,
  onReject,
  onApprove,
  onSubmit,
  moveToStep,
  LAST_STEP_INDEX,
}: IStepActionButtonsProps) => {
  const { current, setStep, bias, isDisabled } = step;

  const moveTo = (step: number) => {
    if (step >= bias[0] && step <= bias[1]) setStep(step);
  };

  const { messages, isReady } = isDisabled(current);

  return (
    <div className="d-flex justify-content-end mt-3">
      {!isFinished &&
        (pisRequest.status === "CREATED" || hasApproverPermission) &&
        current > 0 && (
          <button
            className="btn btn-primary me-auto"
            disabled={isSaveOrSubmitInProgress}
            onClick={onSave}
          >
            Save
          </button>
        )}

      <div className="d-flex gap-3" style={{ height: 38 }}>
        {isSaveOrSubmitInProgress && (
          <Spinner hideLabel={true} mediumSpinner={true} />
        )}

        {current > bias[0] && (
          <button
            className="btn btn-outline-primary ms-auto"
            disabled={current === 0 || isSaveOrSubmitInProgress}
            onClick={() => moveToStep(current - 1)}
          >
            Previous
          </button>
        )}

        {current < bias[1] && (
          <button
            className="btn btn-primary ms-auto"
            disabled={isSaveOrSubmitInProgress || isReady}
            onClick={() => moveToStep(current + 1)}
          >
            {"Next"}
          </button>
        )}

        {current === LAST_STEP_INDEX && pisRequest.status === "CREATED" && (
          <button
            className="btn btn-primary ms-auto"
            // disabled={isStepDisabled(step) || isSaveOrSubmitInProgress}
            disabled={isSaveOrSubmitInProgress}
            onClick={onSubmit}
          >
            {"Submit for Approval"}
          </button>
        )}

        {approverValidation(
          step?.current,
          LAST_STEP_INDEX,
          pisRequest,
          hasApproverPermission,
          hasGroup,
        ) && (
          <>
            <button
              className="btn btn-danger ms-auto"
              disabled={isReady || isSaveOrSubmitInProgress}
              onClick={onReject}
            >
              {"Reject"}
            </button>

            <button
              className="btn btn-primary ms-auto"
              disabled={isReady || isSaveOrSubmitInProgress}
              onClick={onApprove}
            >
              {"Approve"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
